import { createContext, useContext, useState } from 'react';

const ReportAttendanceContext = createContext();

const initialState = {
  selectedTab: 'operator',
};

const startedAt = new Date();
startedAt.setDate(1);

const initialFilterState = {
  page: 1,
  limit: 10,
  search: '',
  startedAt,
  endedAt: new Date(),
  brand: null,
};

const ReportAttendanceProvider = ({ children }) => {
  const [state, setState] = useState(initialState);
  const [filterState, setFilterState] = useState(initialFilterState);

  const updateState = (payload) => setState((prev) => ({ ...prev, ...payload }));
  const updateFilterState = (payload) => setFilterState((prev) => ({ ...prev, ...payload }));
  const resetFilterState = () => setFilterState(initialFilterState);

  return (
    <ReportAttendanceContext.Provider value={{ updateState, ...state, updateFilterState, filterState, resetFilterState }}>
      {children}
    </ReportAttendanceContext.Provider>
  );
};

export const useReportAttendanceState = () => {
  return useContext(ReportAttendanceContext);
};

export default ReportAttendanceProvider;
